module.exports = __webpack_public_path__ + "static/media/jetpure-1.32660656.jpg";